import React from 'react';

const Testimonials = () => (
  <section className="py-20 px-4 bg-white text-center">
    <h2 className="text-3xl font-bold mb-8">What Our Clients Say</h2>
    <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-8">
      <div className="bg-gray-100 p-6 rounded-lg shadow hover:shadow-lg transition">
        <p className="mb-4">
          "The team provided outstanding water treatment solutions, improving our efficiency dramatically."
        </p>
        <h4 className="font-semibold">— Rajesh Kumar, Manufacturing</h4>
      </div>
      <div className="bg-gray-100 p-6 rounded-lg shadow hover:shadow-lg transition">
        <p className="mb-4">
          "Highly professional and reliable service. Our water quality has never been better."
        </p>
        <h4 className="font-semibold">— Kumar, Pharmaceuticals</h4>
      </div>
    </div>
  </section>
);

export default Testimonials;
